import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { objectToQuery } from "../../ObjectToQuery";
import { Image } from "./GetInvoice.query";

class ResponseCustomer {
    id: string;
    mobile: string;
    cart_id: string;
    user_id: string;
    avatar_id: string;
    avatar: Image;
    blocked: boolean;
    dateCreated: Date;
    dateBlocked: Date;
}

class Response {
    customers: ResponseCustomer[];
    count: number;
}

class getCustomersQuery  {
    page = 0;
    per_page: number;
    search: string = null;
}

export function getCustomers(instance_id: number, params: getCustomersQuery): Promise<AxiosResponse<Response>>{
    const query = `/instance/${instance_id}/customers?${objectToQuery(params)}`;
    return Cirus.get(query);
}